<template>
  <div class="raw-hdd-info">
    <!-- 硬盘释放 -->
    <div class="rd-header">
<!--      <span class="rd-title">硬盘释放</span>-->
      <span>
        <el-tag type="primary"  effect="dark" style="width: 70px;line-height: 25px;height:25px">硬盘释放</el-tag>
        <template v-if="isNeedMore">
          <span style="margin-left: 10px" v-html="getHddType(rawHddInfo?.hddType)"></span>
        </template>
      <slot name="operation"></slot>
      </span>
      <div class="rd-header__right">
        <span class="rd-count" v-if="selectDetail?.approvalInfos?.length>1" @click="dialogVisible=true">共 {{ selectDetail?.approvalInfos?.length || 0 }} 条记录<i v-html="viewDetailIcon()"></i></span>
        <!-- 额外的头部操作（如链接释放入口），由外部传入 -->
        <slot name="extra"></slot>
      </div>
      <!--      <span class="rd-count" @click="dialogVisible=true">共{{10}}条记录<i v-html="viewDetailIcon()"></i></span>-->
    </div>
    <div class="rd-body">
      <div class="rd-row">
        <span class="rd-lbl">数据截图：</span>
        <span class="rd-val rd-link" @click="lookCopyData()"><i v-html="viewDetailIcon()"></i>查看</span>
      </div>
      <template v-if="!isNeedMore">
        <div class="rd-row">
          <span class="rd-lbl">收件人：</span>
          <span class="rd-val">{{ rawHddInfo?.receiverName || 'NA' }}</span>
        </div>
        <div class="rd-row">
          <span class="rd-lbl">收件电话：</span>
          <span class="rd-val">{{ rawHddInfo?.receiverPhone || 'NA' }}</span>
        </div>
        <div class="rd-row">
          <span class="rd-lbl">收件地址：</span>
          <w-ellipsis-and-look class="w-ellipsis-and-look"
                               :text="rawHddInfo?.address || 'NA'"
                               :column="{title:'收件人地址'}" :onlyDetail="false">
          </w-ellipsis-and-look>
        </div>
      </template>
      <div class="rd-row">
        <span class="rd-lbl">快递单号：</span>
        <span class="rd-val">{{ rawHddInfo?.courierNo || 'NA' }}</span>
      </div>
      <div class="rd-row">
        <span class="rd-lbl">寄送时间：</span>
        <span class="rd-val">{{ rawHddInfo?.issuedTime || 'NA' }}</span>
      </div>

      <template v-if="!isNeedMore">
        <div class="rd-row">
          <span class="rd-lbl">硬盘类型：</span>
          <span class="val"> <span v-html="getHddType(rawHddInfo?.hddType)"></span></span>
        </div>
        <div class="rd-row">
          <span class="rd-lbl">硬盘大小：</span>
          <span class="rd-val">{{ rawHddInfo?.numberOrSize || 'NA' }}</span>
        </div>
      </template>
      <div class="rd-row" v-if="rawHddInfo?.hddType === 'HDD_BORROW'">
        <span class="rd-lbl">返回时间：</span>
        <span class="rd-val" v-if="rawHddInfo?.returnTime">{{ rawHddInfo?.returnTime }}</span>
        <span class="rd-val rd-warn" v-else>待返回</span>
      </div>
      <template v-if="isNeedMore">
        <span class="rd-row rd-more" title="查看硬盘释放全部信息" @click="openAllInfo">
          <i class="moreIcon" v-html="viewDetailIcon()"></i>点击查看更多
        </span>
      </template>
    </div>

    <!-- 硬盘释放全部信息 -->
    <el-dialog
        title="硬盘释放信息"
        :visible.sync="allInfoVisible"
        width="720px"
        :append-to-body="true"
        :destroy-on-close="true">
      <el-descriptions class="hdd-desc" :column="2" border >
        <el-descriptions-item label="硬盘类型">
          <span v-html="getHddType(rawHddInfo?.hddType)"></span>
        </el-descriptions-item>
        <el-descriptions-item label="硬盘大小">
          {{ rawHddInfo?.numberOrSize || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item label="数据截图">
          <span class="rd-link" @click="lookCopyData()"><i v-html="viewDetailIcon()"></i>查看</span>
        </el-descriptions-item>
        <el-descriptions-item label="快递单号">
          {{ rawHddInfo?.courierNo || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item label="寄送时间">
          {{ rawHddInfo?.issuedTime || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item label="收件人">
          {{ rawHddInfo?.receiverName || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item label="收件电话" :span="2">
          {{ rawHddInfo?.receiverPhone || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item label="收件地址" :span="2">
          {{ rawHddInfo?.address || 'NA' }}
        </el-descriptions-item>
        <el-descriptions-item v-if="rawHddInfo?.hddType === 'HDD_BORROW'" label="返回时间">
          <span v-if="rawHddInfo?.returnTime">{{ rawHddInfo?.returnTime }}</span>
          <span v-else class="rd-warn">待返回</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- 释放记录弹框 -->
    <approval-record-dialog
        :show-dialog.sync="dialogVisible"
        title="硬盘释放记录"
        width="650px"
        :columns="columns"
        :project-id="selectDetail.id||''"
        :table-data="selectDetail.approvalInfos || []">
    </approval-record-dialog>
    <show-my-img v-if="showImgDialog" :show-dialog.sync="showImgDialog" :imgDetail="imgDetail"></show-my-img>
  </div>
</template>
<script>
import {carIcon, viewDetailIcon} from "@/utils/iconUtils";
import ApprovalRecordDialog from "@/components/RawDataReleaseInfo/ApprovalRecordDialog.vue";
import {getHddCopyDataByProjectSoleKey} from "@/api/dilivery";
import ShowMyImg from "@/components/RawDataReleaseInfo/showMyImg.vue";

export default {
  name: "RawHddInfo",
  components: {ShowMyImg, ApprovalRecordDialog},
  props: {
    selectDetail: {
      type: Object,
      default: () => ({})
    },
    isNeedMore: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: false,
      // 硬盘释放全部信息弹框
      allInfoVisible: false,
      columns: [
        {title: '样本数', dataIndex: 'sampleNum', key: 'sampleNum', width: 100},
        {title: '释放时间', dataIndex: 'operateTime', key: 'operateTime'},
        {title: '快递单号', dataIndex: 'courierNo', key: 'courierNo'},
        {title: '收件人', dataIndex: 'receiverName', key: 'receiverName'},
      ],
      showImgDialog:false,
      imgDetail:{
        imgPath: '',
      },
      hddType:{
        'HDD_BUY': '公司硬盘（客户购买）',
        'HDD_BORROW': '公司硬盘（借用）',
        'HDD_OWN': '客户硬盘'
      },
    }
  },
  computed: {
    rawHddInfo() {
      return this.selectDetail?.rawInfo?.HDD || {}
    }
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    carIcon() {
      return carIcon
    },
    lookSampleInfo() {
      this.$emit('lookSampleInfo', this.selectDetail)
    },
    // 打开“查看全部信息”弹框
    openAllInfo() {
      this.allInfoVisible = true
    },
    async lookCopyData() {
      this.showImgDialog = true
      const res = await getHddCopyDataByProjectSoleKey(this.selectDetail.projectSoleKey)
      if(res?.code===200){
        this.imgDetail.imgPath = res.data
      }
    },
    getHddType(hddWay) {
      let hddSource = ''
      let type = 'el-tag el-tag--mini el-tag--light'
      let style = 'background-color: #FFFFFF;'
      hddSource = '客户硬盘'

      switch (hddWay) {
        case 'HDD_OWN':
          hddSource = '客户硬盘';
          style += 'color:#3e8fe4;border: 1px solid #9dc1fa'
          type += ' el-tag--primary'
          break
        case 'HDD_BORROW':
          hddSource = '公司硬盘 (借用)';
          type += 'el-tag--warning'
          style += 'color:#e08700;border: 1px solid #e7b467'

          break
        case 'HDD_BUY':
          hddSource = '公司硬盘(客户购买)';
          type += ' el-tag--success'
          style += 'color:#4c9825;border: 1px solid #74b454'
          break

      }
      return `<span style="${style}" class="${type}">${hddSource}</span>`
    }
  },

}
</script>

<style scoped>
/deep/.el-dialog__body{
  padding-top: 15px!important;
}
.raw-hdd-info {
  font-size: 13px;
}
/* 头部：彩色标题 + 底部浅色分隔线 */
.rd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
  padding-bottom: 3px;
}
.rd-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: .5px;
  color: #2c6fbb;
}
/* 头部右侧：记录数 + 外部按钮同一行 */
.rd-header__right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rd-count {
  font-size: 12px;
  color: #2c6fbb;
  cursor: pointer;
}
.rd-body {
  line-height: 1.3;
}
.rd-row {
  display: flex;
  align-items: baseline;
  padding: 1px 0;
}
.rd-lbl {
  width: 5em;
  text-align: justify;
  text-align-last: justify;
  color: #5389c0;
  white-space: nowrap;
  flex-shrink: 0;
}
.rd-val {
  color: #5389c0;
  font-weight: 500;
  word-break: break-all;
}

.rd-link {
  color: #2c6fbb;
  font-weight: 500;
  cursor: pointer;
  transition: opacity .15s;
}

.rd-warn {
  color: #f14444;
}
/deep/ .w-ellipsis-and-look svg {
  width: 15px !important;
  height: 15px !important;
}
/deep/ .w-ellipsis-and-look {
 color:#5389c0 ;
}
.rd-count:hover {
  opacity: .7;
  text-decoration: underline;
}
.rd-link:hover {
  opacity: .7;
  text-decoration: underline;
}
/deep/ .moreIcon path {
fill: #5daf34!important;
}

/* 点击查看更多 */
.rd-more {
  cursor: pointer;
  color: #5daf34;
}
.rd-more:hover {
  opacity: .75;
  text-decoration: underline;
}

/* 全部信息弹框 */
.hdd-desc {
  font-size: 13px;
}
.hdd-desc >>> .el-descriptions-item__label {
  //color: #5389c0;
  word-break: keep-all;
}
.hdd-desc >>> .el-descriptions-item__content {
  //color: #303133;
  word-break: break-all;
}
</style>
